export const BELABOX_STATUS_ELEMENT_KIND = "belabox.status";
